import MobileNav from "./mobile-nav/MobileNav";

const mobileNavRoot = document.getElementById('mobile-nav');
const mobileNavOptions = {
    toggleSelector: '.mobile-nav-toggle > a',
    appendToRootList: [
        '#mobile-nav-cta'
    ]
};
const mobileNav = new MobileNav(mobileNavRoot, mobileNavOptions);


// News Filters: Ensure only one filter is selected at a time
function initNewsFilters() {
    const themeSelect = document.getElementById('filter-theme');
    const countrySelect = document.getElementById('filter-country');
    const form = document.getElementById('news-filters');

    if (!themeSelect || !countrySelect || !form) return;

    themeSelect.addEventListener('change', function () {
        countrySelect.value = '';
        form.submit();
    });

    countrySelect.addEventListener('change', function () {
        themeSelect.value = '';
        form.submit();
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsFilters);
} else {
    initNewsFilters();
}

// Accordion functionality
document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.accordion-item__trigger');
    if (!trigger) return;

    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    trigger.setAttribute('aria-expanded', !isOpen);
    panel.hidden = isOpen;
});

